export class MoovVariableDTO{
    public id!: number;
    public name!: string;
    public value!: string;
    public customerId!: number; //if not set, then available to all customers. can only be created by super admin
    public added!: string;
    public edited!: string;
    public addedByUserId!: number;
    public editedByUserId!: number;
}